export default "__VITE_ASSET__DZ6cdT47__"